module.exports = __webpack_public_path__ + "img/delete.6f5c236f.svg";